import { render, staticRenderFns } from "./NewTeacher.vue?vue&type=template&id=212961d4&scoped=true&"
import script from "./NewTeacher.vue?vue&type=script&lang=js&"
export * from "./NewTeacher.vue?vue&type=script&lang=js&"
import style0 from "./NewTeacher.vue?vue&type=style&index=0&id=212961d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212961d4",
  null
  
)

export default component.exports